import { declareRoute } from "utilities/routes/route.utility";

export const adminAgentsRoute = declareRoute("/admin/agents");
